<template>
  <div class="buy">
    <a-form
      :form="form"
      :class="{'en-buy-form': isEnglish}"
      @submit="handleToPay"
    >
      <div class="buy_list">
        <div class="buy_item">
          <p class="item_title">
            {{ $t('message["1325"]') }}：
          </p>
          <div class="item_main buy_input">
            {{ serviceInfo.projectname }}
          </div>
        </div>
        <div class="buy_item">
          <p class="item_title">
            {{ $t('message["475"]') }}：
          </p>
          <div class="item_main buy_input">
            <h2 class="total_price title_price">
              {{ PRICE }}{{ $t('message["1524"]') }}
            </h2>
          </div>
        </div>
        <div class="buy_item buy-number-item">
          <a-form-item class="buy_input ">
            <p class="item_title">
              {{ $t('message["396"]') }}：
            </p>
            <div class="item_main">
              <a-input-number
                v-decorator="[
                  'num',
                  {initialValue: payData.num}
                ]"
                class="input_num"
                :min="userMinNum"
                :max="MAX_LIMIT_NUM"
                @change="changeNumber"
              />
              <span class="num_suffx">{{ isEnglish ? '' : $t('message["929"]') }}</span>
              <p
                class="buy-service-tip"
                :class="{'buy-serviece-tip2': isEnglish}"
              >
                {{ numberLimit }}
              </p>
            </div>
          </a-form-item>
        </div>
        <div class="buy_item">
          <p class="item_title">
            {{ $t('message["310"]') }}：
          </p>
          <div class="item_main buy_input">
            <div class="term_tag">
              <span>{{ beginDate }}～{{ endDate }}</span>
            </div>
          </div>
        </div>
        <div class="buy_item">
          <p class="item_title">
            {{ $t('message["1595"]') }}：
          </p>
          <div class="item_main buy_input clearfix">
            <h2 class="total_price fl">
              {{ payData.money }}{{ $t('message["1523"]') }}
            </h2>
            <div
              v-if="priceDiff > 0"
              class="price-diff-con"
            >
              <span class="origin-price">{{ originPrice }} {{ $t('message["1523"]') }}</span>
              <em>（{{ disacountTips[0] }}{{ priceDiff }} {{ disacountTips[1] }}）</em>
            </div>
          </div>
        </div>
        <div class="buy_item">
          <div class="item_main buy_input">
            <a-button
              type="primary"
              html-type="submit"
            >
              {{ $t('message["603"]') }}
            </a-button>
          </div>
        </div>
      </div>
      <!-- 支付提交 -->
      <form
        v-if="isShowForm"
        :id="formId"
        method="post"
        :action="posturl"
      >
        <input
          v-for="(value, key) in keyDatas"
          :key="key"
          :name="key"
          type="hidden"
          :value="value"
        >
      </form>
    </a-form>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapActions, mapState } from 'vuex'
import { getDateTime, isNumber } from '@/pc/config/service/common'
import { getLang } from '@/lib/storage'

const MAX_LIMIT_NUM = 1000
const MIN_LIMIT_NUM = 1
const PRICE = 440

export default {
  props: {
    page: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      PRICE,
      MAX_LIMIT_NUM,
      MIN_LIMIT_NUM,
      form: this.$form.createForm(this),
      payData: {
        num: this.userMinNum,
        servicelimit: 1, // 购买年数
        money: PRICE
      },
      formId: Math.random().toString(10).substring(2),
      formDatas: {},
      isShowForm: true,
      endDate: '',
      originPrice: 0
    }
  },
  computed: {
    ...mapState('service', ['serviceInfo']),
    posturl () {
      return this.formDatas.posturl
    },
    keyDatas () {
      return this.formDatas.data
    },
    beginDate () {
      if (this.serviceInfo.totimenew === 0) {
        return getDateTime(new Date(), 0)
      } else {
        return getDateTime(this.serviceInfo.totimenew, 0)
      }
    },
    userMinNum () {
      const { serviceInfo } = this
      return serviceInfo.user_num * 1 ? serviceInfo.user_num * 1 : this.MIN_LIMIT_NUM
    },
    priceDiff () {
      const { originPrice, payData } = this
      return originPrice - payData.money
    },
    numberLimit () {
      const lang = this.getLang()
      const { userMinNum } = this
      if (lang === 'zh') {
        return `当前项目人数为${userMinNum}人，购买人数不能低于${userMinNum}人`
      } else {
        return `There are ${userMinNum} members in the project, you can not purchase an amount less than ${userMinNum}.`
      }
    },
    disacountTips () {
      return this.$t('message["1476"]').split('|')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  watch: {
    serviceInfo: {
      handler (val) {
        // debugger
        if (val) {
          const { user_num: userNum } = this.serviceInfo
          this.initPayData(Number(userNum))
          if (this.serviceInfo.totimenew === 0) {
            this.endDate = getDateTime(new Date(), 1, 2)
          } else {
            this.endDate = getDateTime(this.serviceInfo.totimenew, 1, 2)
          }
        }
      },
      deep: true
    }
  },
  created () {
    if (this.serviceInfo.totimenew === 0) {
      this.endDate = getDateTime(new Date(), 1, 2)
    } else {
      this.endDate = getDateTime(this.serviceInfo.totimenew, 1, 2)
    }
  },
  methods: {
    ...mapActions('config/service', ['getCountPrice', 'pay']),
    isNumber,
    getLang,
    initPayData (userLimit) {
      let params = this.perpareInitParams(userLimit)
      // console.log(params)
      this.getPrice(params)
      this.$set(this.payData, 'num', userLimit)
    },
    perpareInitParams (userLimit) {
      let data = this.setFormFieldsValue('num', userLimit)
      data = Object.assign(data, { servicelimit: this.payData.servicelimit }, { price: PRICE }, { projectid: this.serviceInfo.projectid })
      return data
    },
    handleToPay (e) {
      e.preventDefault()
      const _this = this
      _this.form.validateFields((err, values) => {
        if (!err) {
          _this.toPay()
        }
      })
    },
    async getPrice (data) {
      const chain = await this.getCountPrice(data)
      chain.onSuccess(res => {
        const { discountprice, originalprice } = res
        this.payData.money = discountprice
        this.originPrice = originalprice
      })
        .fetch()
    },
    async toPay () {
      let params = Object.assign(this.redressFormValue(true),
        { type: 3, price: PRICE, money: this.payData.money, projectid: this.serviceInfo.projectid })
      const chain = await this.pay()
      chain.params(params)
        .onSuccess((res, allRes) => {
          if (!res.error && !(res.hasOwnProperty('redirect'))) {
            this.isShowForm = true
            this.formDatas = res
            this.$emit('formHandler')
            setTimeout(() => {
              document.getElementById(this.formId).submit()
              this.isShowForm = false
              // location.reload()
            }, 1000)
          }
        })
        .fetch()
    },
    // 购买名额
    changeNumber (value) {
      let num = isNumber(value) ? value : this.userMinNum
      let data = this.setFormFieldsValue('num', num)
      this.getPrice(data)
    },
    setFormFieldsValue (field, number) {
      let data = this.redressFormValue(true)
      // console.log(data)
      data[field] = number
      data = Object.assign(data, { price: PRICE }, { type: 3, projectid: this.serviceInfo.projectid, servicelimit: this.payData.servicelimit })
      return data
    },

    redressFormValue (isReturn = false) {
      let formData = this.form.getFieldsValue()
      for (let key in formData) {
        // console.log(key, !isNumber(formData[key]))
        if (!isNumber(formData[key])) {
          formData[key] = this.userMinNum
          this.form.setFieldsValue({ [key]: this.userMinNum })
        }
      }
      if (isReturn) {
        return formData
      }
    }
  }
}
</script>

<style scoped lang="scss">
.buy::v-deep {
  width: 100%;
  background: #fff;
  margin-top: -20px;
  .en-buy-form {
    .item_title {
      width:140px  !important;
    }
    .item_main {
      left: 140px !important;
    }
  }
  .buy_list {
    margin-left: 30px;
    .buy_item {
      position: relative;
      min-height: 56px;
      margin: 15px 0;
      .buy_input {
        position: absolute;
        top: 50%;
        transform: translateY(-50%)
      }
      .item_title {
        width: 84px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        font-size:14px;
        color:#666;
        line-height:24px;
        text-align: right;
      }
      .item_main {
        display: inline-block;
        margin: 0 15px;
        position: absolute;
        left: 85px;
        .buy-service-tip {
          color:#b3b3b3;
          width: 520px;
          margin-top: -18px;
        }
        button {
          background:linear-gradient(360deg,rgba(80,119,170,1) 0%,rgba(96,143,204,1) 100%);
          box-shadow:0px 1px 1px 0px rgba(255,255,255,0.5);
          border-radius:4px;
          border:1px solid rgba(80,119,170,1);
        }
        button:hover {
          background:linear-gradient(360deg,rgba(96,143,204,1) 0%,rgba(80,119,170,1) 100%);
        }
        .total_price {
          font-size: 24px;
          line-height: 24px;
          color: #5077AA;
          font-weight: 600
        }
        .title_price {
          color: #333;
          font-size: 14px;
        }
        .term_tag {
          width: 320px;
          height: 32px;
          background: #ebebeb;
          border-radius: 4px;
          border:1px solid #d6d6d6;
          span {
            line-height: 32px;
            color: #666;
            margin: 0 12px;
          }
        }
        .input_num {
          position: absolute;
          top: -18px;
          width: 320px !important;
        }
        .num_suffx {
          position: relative;
          left: 270px;
          top: -18px;
          z-index: 100
        }
      }
    }
    .buy-number-item {
      margin-bottom: 20px;
    }
    .price-diff-con {
      float: left;
      margin-left: 6px;
      line-height: 24px;
      span{
        text-decoration:line-through;
        color: #b3b3b3;
      }
      em {
        color: #F6A953;
        font-style: normal;
      }
    }
  }
}
 .buy-serviece-tip2 {
    margin-top: 18px !important;
  }

</style>
